import React, { useState, useEffect } from 'react';
import Skeleton from '../OtherElements/CustomSkeleton';
import axios from '../../api/axios';
import Select from 'react-select';
import FormHelperText from '@material-ui/core/FormHelperText';

const SelectLoad = ({ load, onSelect, disabled, error = false }) => {
  const [loads, setLoads] = useState(null);
  disabled === undefined && (disabled = false);
  const loadLoads = async () => {
    try {
      let { data: loadTypes } = await axios.get(`/api/v1/admin/load/type/list`);
      loadTypes.reverse();
      setLoads(loadTypes);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const handleSelect = (option) => {
    const load = loads.find((p) => p._id === option.value);
    onSelect(load);
  };

  useEffect(() => {
    loadLoads();
  }, []);
  return (
    <>
      {!!loads ? (
        <div>
          <Select
            options={loads.map((load) => ({
              label: load.title,
              value: load._id,
            }))}
            isMulti={false}
            isSearchable={true}
            placeholder="حالت بارگیری"
            value={!!load ? { label: load.title, value: load._id } : null}
            onChange={(load) => handleSelect(load)}
            noOptionsMessage={() => 'حالت بارگیری یافت نشد.'}
            isDisabled={disabled}
            styles={{
              menu: (provided, state) => ({
                ...provided,
                zIndex: 2,
              }),
            }}
          />
          {error ? <FormHelperText error>{error}</FormHelperText> : null}
        </div>
      ) : (
        <Skeleton height={50} />
      )}
    </>
  );
};

export default SelectLoad;
